import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export const useReceiptApi = () => {
    const callApi = useApiCall();

    const GetReciptCode = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_CODE, data, onSuccess, onError);
    };

    const SavePurchaseRecipt = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.SAVE_PURCHASE_RECEIPT, data, onSuccess, onError);
    };

    const UploadAttachment = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.UPLOAD_ATTACHMENT, data, onSuccess, onError);
    };

    const GetReciptList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_LIST, data, onSuccess, onError);
    };


    const ExportToPdf = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.EXPORT_TO_PDF, data, onSuccess, onError);
    }

    const ExportToXls = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.EXPORT_TO_XLS, data, onSuccess, onError);
    }
    const GetReciptByID = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_BY_ID, data, onSuccess, onError);
    };
    const GetReciptAttachments = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.GET_RECEIPT_ATTACHMENTS, data, onSuccess, onError);
    };
    const GetPurchaseHistoryList = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.RECEIPT.GET_PURCHASE_HISTORY_LIST, data, onSuccess, onError);
    };

    /*
    const getOrderList = (data: any, onSuccess: Function, onError: Function) => {
        console.log("getOrderList", data);
        callApi(SAGA_ACTIONS.PURCHASE_ORDER.LIST, data, onSuccess, onError);
    };    
    */



    return {
        GetReciptCode,
        SavePurchaseRecipt,
        UploadAttachment,
        GetReciptList,
        ExportToPdf,
        ExportToXls,
        GetReciptByID,
        GetReciptAttachments,
        GetPurchaseHistoryList
    };
};


